module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v("Training  " + _vm._s(_vm.locationName))])]), _vm._v(" "), (!_vm.isediting && !_vm.isaddding) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "10px",
      "color": "white"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Add")])]) : _vm._e(), _vm._v(" "), (_vm.isediting || _vm.isaddding) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("View Training")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isediting && !_vm.isaddding),
      expression: "!isediting && !isaddding"
    }],
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "logWizard"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs  nav-justified bg-muted"
  }, [_c('li', {
    staticClass: "active",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "fli"
    }
  }, [_c('a', {
    attrs: {
      "id": "f_tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        return _vm.showFtab()
      }
    }
  }, [_vm._v("Training Management")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "sli"
    }
  }, [_c('a', {
    attrs: {
      "id": "s_tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        return _vm.showStab()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Training Schedule")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content b-0 m-b-0"
  }, [_c('div', {
    staticClass: "tab-pane p-t-10 active in",
    attrs: {
      "id": "profile-tab-1"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    ref: "dragtable",
    attrs: {
      "data": _vm.trainings,
      "columns": _vm.compliance_columns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "TrainingDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("fdate")(props.row.TrainingDate)))])]
      }
    }, {
      key: "SessionComplete",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-primary",
          staticStyle: {
            "max-width": "100%",
            "overflow": "hidden",
            "text-overflow": "ellipsis"
          },
          attrs: {
            "title": "Mark Sessions Complete"
          },
          on: {
            "click": function($event) {
              return _vm.displaySessionUsers(props.row.Id)
            }
          }
        }, [_vm._v("\n                            Mark Sessions Complete\n                          ")])]
      }
    }, {
      key: "TrainingSessions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-primary ",
          staticStyle: {
            "max-width": "100%",
            "overflow": "hidden",
            "text-overflow": "ellipsis"
          },
          attrs: {
            "title": 'Sessions :' + props.row.TrainingSessions.length
          },
          on: {
            "click": function($event) {
              return _vm.viewSessions(props.row.TrainingSessions)
            }
          }
        }, [_vm._v("\n                            Sessions : " + _vm._s(props.row.TrainingSessions.length) + "\n                          ")])]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-edit-button', {
          on: {
            "click": function($event) {
              return _vm.editcol(props)
            }
          }
        }), _vm._v(" "), _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.del(props)
            }
          }
        })], 1)]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane p-t-10 active",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "profile-tab-2"
    }
  }, [_c('TrainingCalender')], 1)])])])], 1), _vm._v(" "), (_vm.isediting || _vm.isaddding) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('el-form', {
    ref: "addCompliance",
    attrs: {
      "model": _vm.Training,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50
    },
    model: {
      value: (_vm.Training.Title),
      callback: function($$v) {
        _vm.$set(_vm.Training, "Title", $$v)
      },
      expression: "Training.Title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Type:",
      "prop": "TrainingTypeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.getSupplyEquipment
    },
    model: {
      value: (_vm.Training.TrainingTypeId),
      callback: function($$v) {
        _vm.$set(_vm.Training, "TrainingTypeId", $$v)
      },
      expression: "Training.TrainingTypeId"
    }
  }, _vm._l((_vm.ttypes), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Description,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Category:",
      "prop": "Category"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.Training.Category),
      callback: function($$v) {
        _vm.$set(_vm.Training, "Category", $$v)
      },
      expression: "Training.Category"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "label": 1
    }
  }, [_vm._v("Pre-service")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "label": 2
    }
  }, [_vm._v("In-Service")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Organizer:",
      "prop": "OrganizerId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.Training.OrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.Training, "OrganizerId", $$v)
      },
      expression: "Training.OrganizerId"
    }
  }, _vm._l((_vm.organizers), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Date:",
      "prop": "TrainingDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.Training.TrainingDate),
      callback: function($$v) {
        _vm.$set(_vm.Training, "TrainingDate", $$v)
      },
      expression: "Training.TrainingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Area Zone:",
      "prop": "AreaZone"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30
    },
    model: {
      value: (_vm.Training.AreaZone),
      callback: function($$v) {
        _vm.$set(_vm.Training, "AreaZone", $$v)
      },
      expression: "Training.AreaZone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Compliance:",
      "prop": "ComplianceRequirementId"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Training.ComplianceRequirementId),
      expression: "Training.ComplianceRequirementId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "compliance_drop"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Training, "ComplianceRequirementId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Reference Doc:",
      "prop": "ComplianceDocumentDetailId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.Training.ComplianceDocumentDetailId),
      callback: function($$v) {
        _vm.$set(_vm.Training, "ComplianceDocumentDetailId", $$v)
      },
      expression: "Training.ComplianceDocumentDetailId"
    }
  }, _vm._l((_vm.rdocs), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Title,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Notes:",
      "prop": "Notes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "maxlength": 400
    },
    model: {
      value: (_vm.Training.Notes),
      callback: function($$v) {
        _vm.$set(_vm.Training, "Notes", $$v)
      },
      expression: "Training.Notes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "model-heading"
  }, [_c('span', {
    staticClass: "heading"
  }, [_c('i', {
    staticClass: "fa fa-user fa-1x"
  }), _vm._v(" Session")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover gride TFtable",
    staticStyle: {
      "max-width": "100%",
      "overflow-x": "auto"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                              Session Date\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              Start Time\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              End Time\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              Session Topic\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              Presenter\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              Assign Attendees\n                            ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.Training.TrainingSessions.length < 1 || _vm.Training.TrainingSessions == null) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-weight": "700",
      "opacity": "0.6",
      "color": "gray"
    }
  }, [_vm._v("Data Empty")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Training.TrainingSessions), function(item, index) {
    return _c('tr', {
      key: item.Id
    }, [_c('td', [_c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "date",
        "format": "MM-dd-yyyy",
        "placeholder": "Pick a date"
      },
      on: {
        "blur": _vm.hydroware_picker_hasBlurred
      },
      model: {
        value: (item.Date),
        callback: function($$v) {
          _vm.$set(item, "Date", $$v)
        },
        expression: "item.Date"
      }
    })], 1), _vm._v(" "), _c('td', [_c('el-time-select', {
      attrs: {
        "placeholder": "Start time",
        "picker-options": {
          start: '08:30',
          step: '00:15',
          end: '24:00',

        }
      },
      on: {
        "blur": _vm.hydroware_picker_hasBlurred
      },
      model: {
        value: (item.StartTime),
        callback: function($$v) {
          _vm.$set(item, "StartTime", $$v)
        },
        expression: "item.StartTime"
      }
    })], 1), _vm._v(" "), _c('td', [_c('el-time-select', {
      attrs: {
        "placeholder": "End time",
        "picker-options": {
          start: '08:30',
          step: '00:15',
          end: '24:00',
          minTime: item.StartTime
        }
      },
      on: {
        "blur": _vm.hydroware_picker_hasBlurred
      },
      model: {
        value: (item.EndTime),
        callback: function($$v) {
          _vm.$set(item, "EndTime", $$v)
        },
        expression: "item.EndTime"
      }
    })], 1), _vm._v(" "), _c('td', [_c('el-input', {
      attrs: {
        "maxlength": 30
      },
      model: {
        value: (item.Topic),
        callback: function($$v) {
          _vm.$set(item, "Topic", $$v)
        },
        expression: "item.Topic"
      }
    })], 1), _vm._v(" "), _c('td', [_c('el-input', {
      attrs: {
        "maxlength": 30
      },
      model: {
        value: (item.Presenter),
        callback: function($$v) {
          _vm.$set(item, "Presenter", $$v)
        },
        expression: "item.Presenter"
      }
    })], 1), _vm._v(" "), _c('td', [_c('h3', {
      on: {
        "click": function($event) {
          return _vm.addUser(index, item.UserIds)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "grey",
        "text-decoration": "underline",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(item.UserIds.length))])])]), _vm._v(" "), _c('td', [_c('hydroware-delete-button', {
      on: {
        "click": function($event) {
          return _vm.removeSession(index)
        }
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm add-session",
    staticStyle: {
      "background-color": "#188ae2 !important",
      "color": "white !important",
      "position": "absolute",
      "top": "2px",
      "right": "15px",
      "z-index": "3",
      "box-shadow": "1px 1px 1px rgba(0, 0, 0, 0.33)"
    },
    attrs: {
      "onclick": "return false;"
    },
    on: {
      "click": function($event) {
        return _vm.addSession()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus",
    staticStyle: {
      "color": "white !important"
    },
    attrs: {
      "id": "sidebar_button"
    }
  }), _vm._v("\n                          Add Session\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover gride TFtable"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                              Supply Item\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              Quantity\n                            ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.Training.SupplyItems.length < 1 || _vm.Training.SupplyItems == null) ? _c('tr', {}, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-weight": "700",
      "opacity": "0.6",
      "color": "gray"
    }
  }, [_vm._v("Data Empty")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Training.SupplyItems), function(item, index) {
    return _c('tr', {
      key: item.Id
    }, [_c('td', [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (item.SupplyItemId),
        callback: function($$v) {
          _vm.$set(item, "SupplyItemId", $$v)
        },
        expression: "item.SupplyItemId"
      }
    }, _vm._l((_vm.supplies), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.SupplyItem,
          "value": item.Id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('td', [_c('el-input', {
      attrs: {
        "maxlength": 30
      },
      model: {
        value: (item.Quantity),
        callback: function($$v) {
          _vm.$set(item, "Quantity", $$v)
        },
        expression: "item.Quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('hydroware-delete-button', {
      on: {
        "click": function($event) {
          return _vm.removeSupply(index)
        }
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "background-color": "#188ae2 !important",
      "color": "white !important",
      "position": "absolute",
      "top": "2px",
      "right": "15px",
      "z-index": "3",
      "box-shadow": "1px 1px 1px rgba(0, 0, 0, 0.33)"
    },
    attrs: {
      "onclick": "return false;"
    },
    on: {
      "click": function($event) {
        return _vm.addSupply()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus",
    staticStyle: {
      "color": "white !important"
    },
    attrs: {
      "id": "sidebar_button"
    }
  }), _vm._v("\n\n\n                          Add Supply Item\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover gride TFtable"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                              Equipment\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                              Quantity\n                            ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.Training.Equipments.length < 1 || _vm.Training.Equipments == null) ? _c('tr', {}, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-weight": "700",
      "opacity": "0.6",
      "color": "gray"
    }
  }, [_vm._v("Data Empty")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Training.Equipments), function(item, index) {
    return _c('tr', {
      key: item.Id
    }, [_c('td', [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (item.EquipmentId),
        callback: function($$v) {
          _vm.$set(item, "EquipmentId", $$v)
        },
        expression: "item.EquipmentId"
      }
    }, _vm._l((_vm.equipments), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Equipment,
          "value": item.Id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('td', [_c('el-input', {
      attrs: {
        "maxlength": 30
      },
      model: {
        value: (item.Quantity),
        callback: function($$v) {
          _vm.$set(item, "Quantity", $$v)
        },
        expression: "item.Quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('hydroware-delete-button', {
      on: {
        "click": function($event) {
          return _vm.removeEquipment(index)
        }
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "background-color": "#188ae2 !important",
      "color": "white !important",
      "position": "absolute",
      "top": "2px",
      "right": "15px",
      "z-index": "3",
      "box-shadow": "1px 1px 1px rgba(0, 0, 0, 0.33)"
    },
    attrs: {
      "onclick": "return false;"
    },
    on: {
      "click": function($event) {
        return _vm.addEquipment()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus",
    staticStyle: {
      "color": "white !important"
    },
    attrs: {
      "id": "sidebar_button"
    }
  }), _vm._v("\n\n\n                          Add Equipment\n                        ")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(!_vm.isediting) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddTraining('addCompliance')
      }
    }
  }, [_vm._v("\n                        Create Training\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.isediting) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateTraining('addCompliance')
      }
    }
  }, [_vm._v("\n                        Update Training\n                      ")]) : _vm._e()])])])])], 1)]) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "eventsModel1",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.eventDetails.length > 0 ? _vm.eventDetails[0].Topic : '') + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.eventDetails), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("fdate")(item.Date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Topic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Presenter))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("ftime")(item.StartTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("ftime")(item.EndTime)))])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "AttendeesModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg ",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-placeholder": "Search...",
      "props": {
        key: 'Id',
        label: 'Name'
      },
      "titles": ['Available', 'Selected'],
      "footer-format": {
        noChecked: '${total} rows checked',
        hasChecked: '${checked}/${total} rows checked'
      },
      "data": _vm.organizers
    },
    on: {
      "change": _vm.userAppend
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "UsersModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "margin-top": "10%"
    }
  }, [_c('div', {
    staticClass: "modal-content modal-gray"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(" Display users ")]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-primary radio-inline"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.filterUser),
      callback: function($$v) {
        _vm.filterUser = $$v
      },
      expression: "filterUser"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "label": 1
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "label": 2
    }
  }, [_vm._v("Completed only")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "label": 3
    }
  }, [_vm._v("Uncompleted only")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "padding": "inherit",
      "background-color": "rgba(23, 95, 156, 0.79)",
      "padding-right": "5px",
      "height": "500px",
      "border-right": "6px solid #edeef3",
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "session-associate"
  }, [_vm._m(4), _vm._v(" "), (_vm.sDetails == null || _vm.sDetails.length < 1) ? _c('li', {
    staticClass: "ng-hide",
    staticStyle: {
      "background-color": "rgba(183, 183, 183, 0.25)",
      "color": "white"
    }
  }, [_c('span', [_vm._v("No Sessions Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sDetails), function(item, index) {
    return _c('li', {
      key: item.id,
      class: {
        'session-active rowSelected': index == _vm.cindex
      },
      attrs: {
        "ng-class": "{'session-active':  Users == session.Users}"
      },
      on: {
        "click": function($event) {
          return _vm.SelectSession(item.Users, index)
        }
      }
    }, [_c('span', {
      staticClass: "ng-binding"
    }, [_vm._v(_vm._s(item.Topic))]), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _c('br'), _c('span', {
      staticClass: "ng-binding"
    }, [_vm._v("Users: " + _vm._s(item.Users.length))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "padding": "inherit",
      "background-color": "rgba(23, 95, 156, 0.79)",
      "height": "500px",
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "session-associate "
  }, [_vm._m(6), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sUsers.length < 1),
      expression: "sUsers.length < 1"
    }],
    staticStyle: {
      "background-color": "rgba(183, 183, 183, 0.25)",
      "color": "white"
    }
  }, [_c('span', [_vm._v("No Users Found")])]), _vm._v(" "), _vm._l((_vm.sUsers), function(item) {
    return (item.UserId && (_vm.filterUser == 2 ? item.IsSessionCompleted : true && _vm.filterUser == 3 ? !item.IsSessionCompleted : true)) ? _c('li', {
      key: item.id,
      staticClass: "ng-scope",
      staticStyle: {
        "padding": "10px"
      }
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "checkbox checkbox-primary col-lg-9",
      staticStyle: {
        "padding-left": "inherit"
      }
    }, [_c('el-checkbox', {
      staticStyle: {
        "padding-left": "inherit"
      },
      model: {
        value: (item.IsSessionCompleted),
        callback: function($$v) {
          _vm.$set(item, "IsSessionCompleted", $$v)
        },
        expression: "item.IsSessionCompleted"
      }
    }, [_c('span', {
      staticStyle: {
        "overflow": "hidden",
        "display": "inline-block",
        "position": "relative",
        "padding-right": "10px",
        "text-overflow": "ellipsis",
        "white-space": "initial",
        "width": "100%",
        "top": "5px"
      },
      attrs: {
        "title": item.Name
      }
    }, [_vm._v(_vm._s(item.Name))])])], 1), _vm._v(" "), _c('span', {
      staticClass: "label label-success",
      class: {
        'label label-success': item.IsSessionCompleted == true, 'label label-danger': item.IsSessionCompleted == false
      }
    }, [(item.IsSessionCompleted == true) ? _c('i', [_vm._v("Completed")]) : _vm._e(), _vm._v(" "), (item.IsSessionCompleted == false) ? _c('i', {
      class: {
        'label label-success': item.IsSessionCompleted == true, 'label label-danger': item.IsSessionCompleted == false
      }
    }, [_vm._v("Not Completed")]) : _vm._e()])]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer ",
    staticStyle: {
      "background-color": "rgba(6, 94, 162, 0.88) !important"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "float": "right",
      "margin-top": "11px"
    },
    on: {
      "click": _vm.UpdateSessionCompletness
    }
  }, [_vm._v("\n          Mark Complete\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Topic")]), _vm._v(" "), _c('th', [_vm._v("Presenter")]), _vm._v(" "), _c('th', [_vm._v("Start Time")]), _vm._v(" "), _c('th', [_vm._v("End Time")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Attendees")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header modelheadercurved"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "text-align": "center",
      "color": "white"
    },
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('h3', [_vm._v("Users Session completion Wizard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background-color": "rgba(14, 106, 113, 0.25)",
      "color": "white"
    }
  }, [_c('span', [_vm._v("SESSIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avtar-box col-lg-3 col-sm-3 col-md-3 col-xs-3"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/images/Dashboard.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background-color": "rgba(14, 106, 113, 0.25)",
      "color": "white"
    }
  }, [_c('span', [_vm._v("USERS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avtar-box col-lg-3 col-sm-3 col-md-3 col-xs-3"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/images/Engineer.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3615cfef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HealthSafety/training.vue
// module id = 797
// module chunks = 1